import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LaCheckboxComponent} from './la-checkbox.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [LaCheckboxComponent],
  exports: [LaCheckboxComponent]
})
export class LaCheckboxModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaCheckboxModule,
      providers: []
    }
  }
}
